import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Detect iOS early (pre-React) so CSS can disable heavy GPU effects
// before first paint, eliminating jank on iPhone Safari.
(() => {
  if (typeof navigator === "undefined") return;
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isIOS) document.documentElement.classList.add("is-ios");
})();

createRoot(document.getElementById("root")!).render(<App />);
